'use strict';

var FaresClassUsageGridController = function FaresClassUsageGridController($scope, commonFaresChartComponentsService, chartFaresService) {
  $scope.dynamicColumnTitleFormatter = function (monthIdx) {
    return $scope.monthItems[+monthIdx].label + ' \'' + $scope.monthItems[+monthIdx].year;
  };
  $scope.monthItems = chartFaresService.sortLegend(commonFaresChartComponentsService.getInitialLegend());
};
FaresClassUsageGridController.$inject = ['$scope', 'CommonFaresChartComponentsService', 'ChartFaresService'];
module.exports = FaresClassUsageGridController;